module.exports = __webpack_public_path__ + "img/rightTrapezoid.95d67b74.png";